import { render, staticRenderFns } from "./BalanceCorrectionForm.vue?vue&type=template&id=f369b1e4&"
import script from "./BalanceCorrectionForm.vue?vue&type=script&lang=js&"
export * from "./BalanceCorrectionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports